<template>
  <div class="telemetry-rpm-gauge-parts">
    <svg
      class="telemetry-rpm-gauge-parts__gauge"
      width="303"
      height="128"
      viewBox="0 0 303 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <clipPath id="telemetry-rpm-gauge-parts__gauge__clip">
        <rect
          width="303"
          :height="gaugeHeight"
          x="0"
          :y="gaugePositionY"
          fill="white"
          opacity="0.8"
        ></rect>
      </clipPath>
      <path
        clip-path="url(#telemetry-rpm-gauge-parts__gauge__clip)"
        opacity="0.5"
        d="M263 16C263 8.26801 256.732 2 249 2H183V4H237C243.627 4 249 9.37258 249 16V111.029C249 114.212 250.264 117.264 252.515 119.515L263 130V16Z"
        fill="#73FF31"
      />
      <path
        clip-path="url(#telemetry-rpm-gauge-parts__gauge__clip)"
        opacity="0.8"
        d="M263 16C263 8.26801 256.732 2 249 2H183V3H249C256.18 3 262 8.8203 262 16V129L263 130V16Z"
        fill="#73FF31"
      />
      <g opacity="0.5">
        <path
          opacity="0.8"
          d="M263 16C263 8.26801 256.732 2 249 2H183V4H237C243.627 4 249 9.37258 249 16V111.029C249 114.212 250.264 117.264 252.515 119.515L263 130V16Z"
          fill="url(#paint0_linear_757_14861)"
        />
        <path
          d="M263 16C263 8.26801 256.732 2 249 2H183V3H249C256.18 3 262 8.8203 262 16V129L263 130V16Z"
          fill="#73FF31"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_757_14861"
          x1="249"
          y1="81.5"
          x2="263"
          y2="81.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#73FF31" stop-opacity="0.5" />
          <stop offset="1" stop-color="#73FF31" />
        </linearGradient>
      </defs>

      <text class="telemetry-rpm-gauge-parts__label" x="70" y="-252.5" transform="rotate(90)">
        ENGINE
      </text>
    </svg>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from '@vue/composition-api'
import useTelemetrySectionUtil from '@/components/RaceVideoPage/RaceVideoDataViewPane/hook/useTelemetrySectionUtil'

/**
 * レース動画再生画面 テレメトリー エンジン回転数 ゲージ値セクションのコンポーネント
 */
export default defineComponent({
  name: 'TelemetryRpmGaugeParts',
  components: {},
  props: {
    /**
     * バリュー値
     */
    value: {
      type: Number,
      required: true,
      default: 0,
    },
    /**
     * ゲージMAX値
     */
    max: {
      type: Number,
      required: true,
      default: 0,
    },
  },
  setup(props) {
    const { adjustPosition } = useTelemetrySectionUtil()

    // 位置指定を整数化
    adjustPosition('.telemetry-rpm-gauge-parts')

    // ゲージ高さ
    const gaugeSvgHeight = 128

    /**
     * gaugeHeight
     * ゲージの高さを算出
     */
    const gaugeHeight = computed(() => (gaugeSvgHeight * props.value) / props.max)

    /**
     * gaugePositionY
     * ゲージのY位置を算出
     */
    const gaugePositionY = computed(
      () => gaugeSvgHeight - (gaugeSvgHeight * props.value) / props.max,
    )

    return {
      gaugeHeight,
      gaugePositionY,
    }
  },
  methods: {},
})
</script>

<style lang="scss" scoped>
.telemetry-rpm-gauge-parts {
  position: absolute;
  left: calc(#{min(4.2667vw, 1.333em)} + 1.6667em);
  top: calc(#{min(4.2667vw, 1.333em)} + 2em);
  width: 25.25em;
  height: 16.6667em;

  &__gauge {
    position: absolute;
    width: 100%;
    z-index: 1;

    rect {
      transition: all linear $telemetryFps;
    }
  }

  &__label {
    fill: $black;
    font-weight: 500;
    font-size: 10px;
    letter-spacing: 0;
  }
}
</style>

<style lang="scss">
.race-telemetry-section {
  &--landscape-primary,
  &--landscape-secondary {
    .telemetry-rpm-gauge-parts {
      top: 2.4em;
    }
  }
}
</style>
